module.exports = __webpack_public_path__ + "static/media/polywork.6e6746f3.svg";